export class UserFirmsResponseModel {
  Id: number;
  UserId: number;
  FirmId: number;
  IsDefaultFirm: boolean;
  IsFirmActive: boolean;
  FirmName: string;

  constructor() {
    this.Id = 0;
    this.UserId = 0;
    this.FirmId = 0;
    this.IsDefaultFirm = false;
    this.FirmName = '';
  }
}
